/**
 * @generated SignedSource<<a22819c8c50caea8cc67b760ed7818cb>>
 * @relayHash fdc2a3da7b702ec9852d4fdd2c51a96c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 118bba66579492894c1a9a57ab2cec46ea6fbf9464ac17d171640ad5e6b72227

import type { ConcreteRequest } from 'relay-runtime';
export type RelatedContentSectionQuery$variables = {
  cypherQuery: string;
  first: number;
  queryContext: string;
};
export type RelatedContentSectionQuery$data = {
  readonly graphStore_cypherQueryV2: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly columns: ReadonlyArray<{
          readonly key: string;
          readonly value: {
            readonly __typename: "GraphStoreCypherQueryV2AriNode";
            readonly data: {
              readonly __typename: "ConfluenceBlogPost";
              readonly blogPostLinks: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
              readonly blogPostTitle: string | null;
            } | {
              readonly __typename: "ConfluencePage";
              readonly pageLinks: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
              readonly pageTitle: string | null;
            } | {
              readonly __typename: "DevOpsPullRequestDetails";
              readonly devOpsPullRequestTitle: string | null;
              readonly devOpsPullRequestUrl: string | null;
            } | {
              readonly __typename: "ExternalPullRequest";
              readonly externalPullRequestTitle: string | null;
              readonly externalPullRequestUrl: string | null;
            } | {
              readonly __typename: "JiraIssue";
              readonly issueKey: string;
              readonly issueSummary: string | null;
              readonly issueUpdated: AGG$DateTime | null;
              readonly issueUrl: AGG$URL | null;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null;
            readonly id: string;
          } | {
            readonly __typename: "GraphStoreCypherQueryV2StringObject";
            readonly stringValue: string;
          } | {
            readonly __typename: "GraphStoreCypherQueryV2TimestampObject";
            readonly timestampValue: AGG$Long;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        }>;
      };
    }>;
  } | null;
};
export type RelatedContentSectionQuery = {
  response: RelatedContentSectionQuery$data;
  variables: RelatedContentSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cypherQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v3 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "cypherQuery"
  },
  {
    "kind": "Variable",
    "name": "queryContext",
    "variableName": "queryContext"
  },
  {
    "kind": "Literal",
    "name": "version",
    "value": "V3"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "stringValue",
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "GraphStoreCypherQueryV2StringObject"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "timestampValue",
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "GraphStoreCypherQueryV2TimestampObject"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "issueKey",
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "alias": "issueSummary",
      "kind": "ScalarField",
      "name": "summary"
    },
    {
      "alias": "issueUrl",
      "kind": "ScalarField",
      "name": "webUrl"
    },
    {
      "alias": "issueUpdated",
      "kind": "ScalarField",
      "name": "updated"
    }
  ],
  "type": "JiraIssue"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "pageTitle",
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "alias": "pageLinks",
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v10/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "blogPostTitle",
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "alias": "blogPostLinks",
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v10/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "externalPullRequestTitle",
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "alias": "externalPullRequestUrl",
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "type": "ExternalPullRequest"
},
v14 = {
  "alias": "devOpsPullRequestTitle",
  "kind": "ScalarField",
  "name": "title"
},
v15 = {
  "alias": "devOpsPullRequestUrl",
  "kind": "ScalarField",
  "name": "url"
},
v16 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RelatedContentSectionQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "GraphStoreCypherQueryV2Connection",
        "kind": "LinkedField",
        "name": "graphStore_cypherQueryV2",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "GraphStoreCypherQueryV2Node",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreCypherQueryV2Column",
                    "kind": "LinkedField",
                    "name": "columns",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v14/*: any*/),
                                      (v15/*: any*/)
                                    ],
                                    "type": "DevOpsPullRequestDetails"
                                  }
                                ]
                              }
                            ],
                            "type": "GraphStoreCypherQueryV2AriNode"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "RelatedContentSectionQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "GraphStoreCypherQueryV2Connection",
        "kind": "LinkedField",
        "name": "graphStore_cypherQueryV2",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphStoreCypherQueryV2Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "GraphStoreCypherQueryV2Node",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreCypherQueryV2Column",
                    "kind": "LinkedField",
                    "name": "columns",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "value",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "CustomerUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "DevOpsFeatureFlag"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "DevOpsOperationsComponentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "DevOpsOperationsIncidentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "DevOpsProjectDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "DevOpsRepository"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "JiraAutodevJob"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "JiraConfluenceRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "JiraCustomRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "JiraIssueRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "JiraWebRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "TeamCustomFieldValue"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "TeamType"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v16/*: any*/),
                                    "type": "ThirdPartyUser"
                                  }
                                ]
                              }
                            ],
                            "type": "GraphStoreCypherQueryV2AriNode"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "118bba66579492894c1a9a57ab2cec46ea6fbf9464ac17d171640ad5e6b72227",
    "metadata": {},
    "name": "RelatedContentSectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e245c457c917aba14b162a6e66ff0c64";

export default node;
